var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 567.33 134.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 191.45,
    y1: 104.47,
    x2: 122,
    y2: 13.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ee7400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d00000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 284.6,
    y1: 111.81,
    x2: 214.82,
    y2: 20.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 381.7,
    y1: 107.93,
    x2: 319.12,
    y2: 26.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 476.32,
    y1: 86.94,
    x2: 415.06,
    y2: 6.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 560.32,
    y1: 107.93,
    x2: 497.74,
    y2: 26.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 108.29,
    y1: 145.26,
    x2: -34.01,
    y2: -33.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 109.96,
    y1: 143.48,
    x2: -32.07,
    y2: -34.9,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M193.95,22.86v79.7h-26.42v-8.44c-1.99,2.18-4.27,3.98-6.82,5.43-5.14,2.88-10.74,4.33-16.81,4.33-6.46,0-12.25-1.28-17.39-3.82-5.14-2.54-9.15-6.53-12.04-11.96-2.88-5.43-4.33-12.35-4.33-20.77V22.86h27.89v39.92c0,6.17,1.15,10.59,3.45,13.28,2.3,2.7,5.55,4.04,9.76,4.04,2.74,0,5.26-.64,7.56-1.91,2.3-1.27,4.08-3.3,5.35-6.09,1.28-2.79,1.91-6.33,1.91-10.64V22.86h27.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M296.69,57.06v45.5h-28.04v-40.95c0-5.68-1.15-9.81-3.45-12.41-2.3-2.59-5.4-3.88-9.32-3.88-3.03,0-5.77.66-8.22,1.98-2.44,1.32-4.35,3.35-5.72,6.09-1.37,2.74-2.05,6.36-2.05,10.86v38.31h-27.89V22.86h26.71v8.76c2.1-2.22,4.5-4.08,7.19-5.6,5.29-2.99,11.25-4.48,17.91-4.48,6.16,0,11.74,1.27,16.73,3.82,4.99,2.54,8.93,6.4,11.82,11.59,2.88,5.19,4.33,11.89,4.33,20.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M378.07,30.49c-7.1-5.96-17.1-8.95-30.02-8.95-6.26,0-12.54.83-18.86,2.49-6.31,1.67-11.71,3.97-16.21,6.9l9.24,18.79c2.74-1.96,6.09-3.57,10.06-4.84,3.96-1.27,7.85-1.91,11.66-1.91,5.88,0,10.16,1.2,12.85,3.59,2.45,2.18,3.78,5.19,3.99,9.03h-15.81c-8.12,0-14.8.95-20.03,2.86-5.24,1.91-9.1,4.67-11.6,8.29-2.49,3.63-3.74,7.88-3.74,12.77,0,4.5,1.15,8.61,3.45,12.33,2.3,3.72,5.67,6.66,10.13,8.81,4.45,2.15,9.8,3.23,16.07,3.23,6.94,0,12.55-1.4,16.8-4.19,2.86-1.86,5.08-4.34,6.68-7.42v10.29h25.98v-44.18c0-12.62-3.55-21.92-10.64-27.89ZM355.47,83.99c-2.5,1.52-5.31,2.27-8.44,2.27s-5.78-.75-7.63-2.27c-1.86-1.52-2.79-3.45-2.79-5.8,0-2.54.9-4.5,2.71-5.87s4.97-2.05,9.47-2.05h12.03v6.75c-1.07,3.13-2.86,5.45-5.35,6.97Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "488.51 22.86 455.93 102.56 427.02 102.56 394.29 22.86 422.91 22.86 442.02 71.71 462.09 22.86 488.51 22.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M556.69,30.49c-7.1-5.96-17.1-8.95-30.02-8.95-6.26,0-12.55.83-18.86,2.49-6.31,1.67-11.72,3.97-16.22,6.9l9.25,18.79c2.74-1.96,6.09-3.57,10.06-4.84,3.96-1.27,7.85-1.91,11.66-1.91,5.87,0,10.15,1.2,12.85,3.59,2.45,2.18,3.78,5.19,3.99,9.03h-15.81c-8.12,0-14.8.95-20.03,2.86-5.24,1.91-9.1,4.67-11.6,8.29-2.49,3.63-3.74,7.88-3.74,12.77,0,4.5,1.15,8.61,3.45,12.33,2.3,3.72,5.67,6.66,10.13,8.81,4.45,2.15,9.8,3.23,16.07,3.23,6.94,0,12.55-1.4,16.8-4.19,2.86-1.86,5.08-4.34,6.68-7.42v10.29h25.98v-44.18c0-12.62-3.55-21.92-10.64-27.89ZM534.08,83.99c-2.49,1.52-5.3,2.27-8.43,2.27s-5.78-.75-7.64-2.27c-1.86-1.52-2.79-3.45-2.79-5.8,0-2.54.91-4.5,2.72-5.87s4.96-2.05,9.47-2.05h12.03v6.75c-1.08,3.13-2.86,5.45-5.36,6.97Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.84,22.9v30.08h.01v-30.08ZM54.18,89.21l9.03,13.23c-2.88-4.66-5.76-9.23-9.03-13.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.88,127.87c-.71-.46-7-2.36-8.44-2.92-11.61-4.51-15.43-8.42-22.16-17.55-1.13-1.53-2.23-3.09-3.29-4.66l-21.69-32.28c6.31-2.96,11.19-7.07,14.66-12.34,3.67-5.58,5.51-12.33,5.51-20.25,0-11.74-4.02-20.99-12.04-27.74S60.86,0,45.79,0H0v102.74h29.06v-27.3h15.72l7.17,10.51,2.23,3.26c3.27,4,6.15,8.57,9.03,13.23,8.38,13.59,16.71,27.97,34.51,31.51,2.06.41,4.2.5,6.29.57,3.83.14,7.68.07,11.49-.28,1.42-.13,2.83-.31,4.24-.56s2.7-.5,3.95-1.03c.05-.02.1-.04.15-.07,1.08-.48,2.07-1.19,2.88-2.06.37-.39.75-.82,1.05-1.27.22-.33.55-.88.25-1.27-.04-.05-.09-.09-.15-.13ZM61.75,45.07c-5.1,3.61-13.61,4.46-24.45,4.55-1.32,1.31-2.45,2.39-3.51,3.36-1.58,1.44-3.01,2.63-4.73,3.94-.87.67-1.81,1.37-2.88,2.15-.54.39-1,.67-1.4.82-.45.17-.81.17-1.09,0-.49-.3-.76-1.15-.84-2.65v-4.26h-.01V19.19c.08-1.18,1.34-2.35,2.56-2.42,1.19,0,2.41-.01,3.66-.01,10.25-.03,21.85-.07,26.14.58,8.6,1.3,12,4.94,11.89,16.29-.05,5.42-1.94,9.04-5.34,11.44Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColor);
export default __webpack_public_path__ + "static/media/logo_color.2ea2a8320c17b134d1e0dce9e8abb77b.svg";
export { ForwardRef as ReactComponent };